import { datadogRum } from '@datadog/browser-rum';

import { telemetryLogin, telemetryLogout } from '@creditornot/browser-telemetry';
import {
  LocalStorageAuthStorage,
  User,
  AnyGrant,
  Authenticator,
  createAuthenticator,
  OAuth2Grant,
} from '@creditornot/wolt-auth';

import { authService } from './authService';

const authStorage = new LocalStorageAuthStorage({ key: 'auth-data' });

type ExtendedAuthenticator = {
  performLogout?: () => void;
} & Authenticator<OAuth2Grant | AnyGrant, User>;

export const authenticator: ExtendedAuthenticator = createAuthenticator({
  authService: authService.woltAuthService,
  storage: authStorage,
});

authenticator.performLogout = async () => {
  if (authService.isOauth()) {
    window.location.href = authService.woltAuthService.getLogoutUri();
  } else {
    await authenticator.logout();
  }
};

// Telemetry listener lives here according to wolt-auth-js docs
// https://github.com/creditornot/wolt-auth-js/blob/main/packages/wolt-auth/README.md#listening-to-authenticator-events
function handleUser(user: User | undefined) {
  if (user) {
    telemetryLogin(user.id);
    datadogRum.setUser({ id: user.id });
  } else {
    telemetryLogout();
  }
}

const initialState = authenticator.getState();
handleUser(initialState.user);

authenticator.subscribe('user', handleUser);
